import { useTranslation } from "react-i18next";
import { buildCloudinaryImageUrl } from "../../../../../utils/CloudinaryImageUrl";

const fmt = (n) => '$' + Number(n || 0).toFixed(2);

export default function OrderSummary({
  items,
  deliveryMethod,
  subtotal = 0,
  itbms = 0,
  shipCost = 0,
  total = 0,
  tip = 0
}) {
  const { t } = useTranslation();
  const totalQty = items.reduce((s, i) => s + i.qty, 0);

  return (
    <div className="ck-summary">
      <p className="ck-summary-title">{t('checkout.orderSummaryTitle')}</p>

      <div style={{ display: 'flex', gap: '.4rem', marginBottom: '1.1rem', flexWrap: 'wrap' }}>
        {items.map(item => (
          <div key={item.id} style={{ position: 'relative' }}>
            <div className="ck-sum-thumb">
              {/* <img src={item.img} alt={item.name} onError={e => e.target.style.opacity = 0} /> */}


              <img src={buildCloudinaryImageUrl({ url: item.img, width: 300, quality: "auto", type: "image" })}
                alt={item.name} onError={e => e.target.style.opacity = 0} />


            </div>
            <span className="ck-sum-thumb-qty">{item.qty}</span>
          </div>
        ))}

        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '.25rem', fontSize: '.75rem', color: 'var(--text-3)' }}>
          {t('checkout.productsCount', { count: totalQty })}
        </div>
      </div>

      <div className="ck-sum-divider" />
      <div className="ck-sum-row">
        <span>{t('cart.subtotal')}</span>
        <span className="ck-sum-row-val">{fmt(subtotal)}</span>
      </div>

      <div className="ck-sum-row">
        <span>{t('checkout.itbms')}</span>
        <span className="ck-sum-row-val">{fmt(itbms)}</span>
      </div>

      <div className="ck-sum-row">
        <span>{t('checkout.shippingLabel')}</span>
        <span className={`ck-sum-row-val${shipCost === 0 ? ' free' : ' brand'}`}>
          {deliveryMethod === 'pickup'
            ? t('checkout.free')
            : deliveryMethod === 'delivery'
              ? (shipCost > 0 ? fmt(shipCost) : '—')
              : '—'}
        </span>
      </div>

      {tip > 0 && (
        <div className="ck-sum-row">
          <span>{t('checkout.tip')}</span>
          <span className="ck-sum-row-val">{fmt(tip)}</span>
        </div>
      )}

      <div className="ck-sum-row total">
        <span>{t('cart.total')}</span>
        <span>{fmt(total)}</span>
      </div>

      {deliveryMethod && (
        <div style={{ marginTop: '.75rem' }}>
          <span className={`ck-tag${deliveryMethod === 'pickup' ? ' pickup' : ' delivery'}`}>
            {deliveryMethod === 'pickup' ? `🏪 ${t('checkout.storePickupTag')}` : `🛵 ${t('checkout.homeDeliveryTag')}`}
          </span>
        </div>
      )}
    </div>
  );
}